
import Cards from "../../../assets/outline/Cards.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardsIcon({ className, dataTestid = "CardsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Cards data-testid={dataTestid} className={classes} {...rest} />
  );
}
